import { SvgIcon } from "@material-ui/core";
import React from "react";

const AvalIcon = (props) => {
  return (
    <SvgIcon
      style={{
        fontSize: 24,
      }}
      {...props}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.36 35.36">
        <path d="M17.68,0h0a17.68,17.68,0,0,0,0,35.36h0A17.68,17.68,0,0,0,17.68,0ZM27,19.3H19.9v-4a2.22,2.22,0,1,0-4.44,0v4H8.34a1.85,1.85,0,0,1-1.83-2.17,11.38,11.38,0,0,1,22.34,0A1.85,1.85,0,0,1,27,19.3Z" />
      </svg>
    </SvgIcon>
  );
};

export default AvalIcon;
